'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dUsers$002dPage$0024 from "./presto.-List-Users-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002477 from "./presto.-Presto-Router$$anon$77.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$76() {
  this.bn9 = null;
  this.bn1 = null;
  this.bn2 = false;
  this.bna = null;
  this.bnb = false;
  this.bne = null;
  this.bn7 = null;
  this.bn8 = false;
  this.bn3 = null;
  this.bn4 = false;
  this.bn5 = null;
  this.bn6 = false;
  this.bnc = false;
  this.bnd = false;
  this.bn9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bne = "ListUsersPage";
}
export { $c_Lpresto_PrestoRouter$$anon$76 as $c_Lpresto_PrestoRouter$$anon$76 };
$p = $c_Lpresto_PrestoRouter$$anon$76.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$76;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$76() {
}
export { $h_Lpresto_PrestoRouter$$anon$76 as $h_Lpresto_PrestoRouter$$anon$76 };
$h_Lpresto_PrestoRouter$$anon$76.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bn9;
});
$p.L = (function() {
  if ((!this.bn2)) {
    this.bn1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bn2 = true;
  }
  return this.bn1;
});
$p.O = (function() {
  if ((!this.bnb)) {
    this.bna = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bnb = true;
  }
  return this.bna;
});
$p.E = (function() {
  return this.bne;
});
$p.t = (function() {
  if ((!this.bn8)) {
    this.bn7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bn8 = true;
  }
  return this.bn7;
});
$p.M = (function() {
  if ((!this.bn4)) {
    this.bn3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bn4 = true;
  }
  return this.bn3;
});
$p.Q = (function() {
  if ((!this.bn6)) {
    this.bn5 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002477.$c_Lpresto_PrestoRouter$$anon$77();
    this.bn6 = true;
  }
  return this.bn5;
});
$p.w = (function() {
  if ((!this.bnd)) {
    this.bnc = false;
    this.bnd = true;
  }
  return this.bnc;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee521) => ((p) => \u03b4scrutinee521))($j_presto$002e$002dList$002dUsers$002dPage$0024.$m_Lpresto_ListUsersPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$76 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$76, "presto.PrestoRouter$$anon$76", ({
  OJ: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$76 as $d_Lpresto_PrestoRouter$$anon$76 };
//# sourceMappingURL=presto.-Presto-Router$$anon$76.js.map
